import { render, staticRenderFns } from "./CookiesModal.vue?vue&type=template&id=83df9de2&scoped=true&"
import script from "./CookiesModal.vue?vue&type=script&lang=js&"
export * from "./CookiesModal.vue?vue&type=script&lang=js&"
import style0 from "./CookiesModal.vue?vue&type=style&index=0&id=83df9de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83df9de2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VRow})
